import React from 'react';
interface Source {
  label: string;
  /** y of the tread this source lands on. */
  y: number;
  /** x of the marker where the step turns up. */
  x: number;
}

/**
 * The library as a step chart: each source your company already has adds
 * another tread, so the line only ever climbs. Laid out from data so labels,
 * leaders, and markers can't drift out of alignment.
 */
const SOURCES: ReadonlyArray<Source> = [{
  label: 'policies',
  y: 322,
  x: 178
}, {
  label: 'brand guides',
  y: 276,
  x: 228
}, {
  label: 'docs & email',
  y: 230,
  x: 278
}, {
  label: 'meeting notes',
  y: 184,
  x: 328
}, {
  label: 'AI chats',
  y: 138,
  x: 378
}, {
  label: 'corrections',
  y: 94,
  x: 424
}];
const STEPS = `M128 368 H178 V322 H228 V276 H278 V230 H328 V184 H378 V138 H424 V94`;
export function LibraryChart() {
  return <svg viewBox="0 0 436 436" width="100%" fill="none" fontFamily="JetBrains Mono, monospace" role="img" aria-label="A step chart: policies, brand guides, docs and email, meeting notes, AI chats, and corrections each add another tread to your instruction library, climbing from day one." data-id="element-212" data-mp="36gk98bu6w7hu">
      <text x="0" y="14" fill="#151A21" fontWeight="600" fontSize="13" letterSpacing="1" data-id="element-213" data-mp="1wj0oyo0su949">
        YOUR LIBRARY
      </text>
      <line x1="0" y1="28" x2="430" y2="28" stroke="#C3CED8" strokeWidth="1" data-id="element-214" data-mp="1rn25neubvhap" />

      <path d={STEPS} stroke="#0E6FA3" strokeWidth="3" fill="none" data-id="element-215" data-mp="1mnyzfr2m3515" />

      {SOURCES.map((s, i) => {
      const last = i === SOURCES.length - 1;
      return <g key={s.label} data-id="element-216" data-mp="2fbuw4vs6kwxx" data-mpi={i}>
            <text x="100" y={s.y + 4} textAnchor="end" fill="#3B434C" fontSize="11.5" data-id="element-217" data-mp="2fbld5s5jzq1q">
              {s.label}
            </text>
            <line x1="108" y1={s.y} x2={s.x - 9} y2={s.y} stroke="#B9C6D2" strokeWidth="1" strokeDasharray="2 3" data-id="element-218" data-mp="25l06dhfq7f7q" />
            <circle cx={s.x} cy={s.y} r={last ? 4.5 : 3.5} fill="#0E6FA3" data-id="element-219" data-mp="2y9e5k0ijwhkv" />
          </g>;
    })}

      <line x1="128" y1="376" x2="426" y2="376" stroke="#C3CED8" strokeWidth="1.5" data-id="element-220" data-mp="wbvny4hkz8pa" />
      <polygon points="434,376 425,371.5 425,380.5" fill="#C3CED8" data-id="element-221" data-mp="10e8o8ddk6eeo" />
      <text x="128" y="396" fill="#49515B" fontSize="11.5" data-id="element-222" data-mp="10fjseeax1o6b">
        day one
      </text>
      <text x="0" y="428" fill="#5E6771" fontSize="12" letterSpacing="1" data-id="element-223" data-mp="mk7yua8hy3qz">
        EVERYTHING THAT CARRIES JUDGMENT, COLLECTED
      </text>
    </svg>;
}